import template from './ko-fields-view.html';

class FieldsComponentViewModel
{
	constructor (params)
	{
		this.params = params;

		this.definitions = ko.observableArray();
		this.internal_values = ko.observable();

		this.values = ko_helper.safe_observable(params.values, {});
		this.filter_schema = ko_helper.safe_observable(params.filter_schema, '');
		this.filter_tables = ko_helper.safe_observableArray(params.filter_tables, []);
		this.incoming_definitions = ko_helper.safe_observableArray(params.definitions, []);

		this.incoming_definitions.subscribe(() => {
			this.updateData();
		});

		this.filter_schema.subscribe(() => {
			this.updateData();
		});

		this.filter_tables.subscribe(() => {
			this.updateData();
		});

		this.definitions.subscribe(val => {
			this.init_fields(val);
		});

		this.updateData();
	}

	async updateData()
	{
		if (this.incoming_definitions()?.length > 0)
			this.definitions(this.incoming_definitions());
		else
		{
			let schema = this.filter_schema();
			let filter_tables = this.filter_tables();

			let all_definitions = await Grape.cache.get('FieldTables');
			let definitions = all_definitions.filter(def => {
				return def.schema == schema &&
					(filter_tables?.length == 0 || filter_tables.indexOf(def.table) >= 0);
			});
			definitions.sort((a,b) => a?.idx - b?.idx);

			this.definitions(definitions);
		}
	}

	init_fields(definitions)
	{
		let internal_values = {};
		let val = this.values();

		definitions?.forEach(section => {
			internal_values[section.table] = {};
			section.fields.forEach(field => {
				internal_values[section.table][field.name] = ko.observable(val?.[section.table]?.[field.name], null);
				internal_values[section.table][field.name].subscribe(() => {
					this.updateValues();
				});
			});
		});

		this.internal_values(internal_values);
	}

	updateValues()
	{
		let values = ko.mapping.toJS(this.internal_values);
		this.values(values);
	}
}

export default {
	name: 'ko-fields-view',
	viewModel: FieldsComponentViewModel,
	module_type: 'ko',
	template: template
};
